// WebSocketProvider.tsx
import { WS_SERVER } from "config"
import { useJwt } from "hooks/useJwt"
import { createContext, useEffect, useState } from "react"

const WebSocketContext = createContext<WebSocket | null>(null)

export function WebSocketProvider({ children }: { children: React.ReactNode }) {
	const [jwt] = useJwt()
	const [socket, setSocket] = useState<WebSocket | null>(null)

	useEffect(() => {
		const ws = new WebSocket(`${WS_SERVER.baseUrl}/?token=${jwt}`)
		ws.addEventListener("open", () => console.log("[WS] aberto"))
		setSocket(ws)

		return () => {
			ws.close(1000, "cleanup")
		}
	}, [jwt])

	return (
		<WebSocketContext.Provider value={socket}>
			{children}
		</WebSocketContext.Provider>
	)
}

export { WebSocketContext }
